import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail?.msg || detail);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const ROLE_LABELS = {
  corporate_admin: "Corporate Admin",
  regional_head: "Cluster Head",
  hotel_gm: "Hotel GM",
  dept_head: "Department Head",
  external_auditor: "External Auditor",
};

export const STATUS_STYLES = {
  scheduled: "bg-blue-50 text-blue-700 border-blue-200",
  in_progress: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  open: "bg-rose-50 text-rose-700 border-rose-200",
  awaiting_review: "bg-violet-50 text-violet-700 border-violet-200",
  closed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-stone-100 text-stone-600 border-stone-300",
};

export function compressImage(file, maxDim = 1024, quality = 0.6) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(img.width * scale));
        canvas.height = Math.max(1, Math.round(img.height * scale));
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        const webp = canvas.toDataURL("image/webp", quality);
        const jpeg = canvas.toDataURL("image/jpeg", quality);
        URL.revokeObjectURL(url);
        const out = webp.startsWith("data:image/webp") && webp.length < jpeg.length ? webp : jpeg;
        if (out && out.startsWith("data:image")) resolve(out);
        else reject(new Error("encode failed"));
      } catch (e) {
        URL.revokeObjectURL(url);
        reject(e);
      }
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });
}

export default api;
